import React from 'react';
import { HiOutlineExclamationTriangle, HiOutlineXMark } from 'react-icons/hi2';

const ConfirmModal = ({
  show,
  title,
  description,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  isBusy = false,
  onCancel,
  onConfirm,
}) => {
  if (!show) {
    return null;
  }

  return (
    <div className="modal-layer" role="presentation">
      <button className="modal-backdrop-button" type="button" aria-label="Close modal" onClick={onCancel} />
      <div className="app-modal" role="dialog" aria-modal="true" aria-labelledby="confirm-modal-title">
        <div className="app-modal-header">
          <span className="modal-alert-icon">
            <HiOutlineExclamationTriangle aria-hidden="true" />
          </span>
          <button className="icon-button" type="button" aria-label="Close modal" onClick={onCancel}>
            <HiOutlineXMark aria-hidden="true" />
          </button>
        </div>
        <div className="app-modal-body">
          <h2 id="confirm-modal-title">{title}</h2>
          {description && <p>{description}</p>}
        </div>
        <div className="app-modal-footer">
          <button className="btn btn-soft-secondary" type="button" onClick={onCancel} disabled={isBusy}>
            {cancelLabel}
          </button>
          <button className="btn btn-danger" type="button" onClick={onConfirm} disabled={isBusy}>
            {isBusy ? 'Working...' : confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
